import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';

const browserHistory = createBrowserHistory();

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: browserHistory,
});

export { createReduxHistory, routerMiddleware, routerReducer };
export default browserHistory;
